<template>
  <transition name="modal-fade">
    <div v-if="visible" class="modal-mask" @click.self="handleClose">
      <div class="modal-panel" role="dialog" aria-modal="true">
        <button type="button" class="close-btn" aria-label="关闭" @click="handleClose">
          <i class="bi bi-x-lg"></i>
        </button>

        <div class="modal-header-bg"></div>
        <div class="modal-title-row">
          <h2><i class="bi bi-gift"></i> 兑换码</h2>
          <p class="subtitle">输入 32 位兑换码，兑换对应套餐点数</p>
        </div>

        <div class="modal-body">
          <div class="input-row">
            <input
              v-model="codeInput"
              type="text"
              class="code-input"
              maxlength="40"
              placeholder="粘贴或输入兑换码"
              autocomplete="off"
              @keyup.enter="handleSubmit" />
            <button type="button" class="submit-btn" :disabled="submitting" @click="handleSubmit">
              {{ submitting ? '兑换中...' : '立即兑换' }}
            </button>
          </div>
          <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>
          <p v-if="successMsg" class="success-msg">{{ successMsg }}</p>

          <div class="history-block">
            <h3>兑换记录</h3>
            <div v-if="loadingHistory" class="history-empty">加载中...</div>
            <div v-else-if="!history.length" class="history-empty">暂无兑换记录</div>
            <ul v-else class="history-list">
              <li v-for="item in history" :key="item.recordId">
                <div class="history-main">
                  <span class="history-name">{{ item.productName || '套餐' }}</span>
                  <span class="history-points">+{{ (item.quotaAmount || 0).toLocaleString() }} 点</span>
                </div>
                <div class="history-meta">
                  <span>{{ item.redeemCode }}</span>
                  <span>{{ item.createTime }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { submitRedeemCode, getRedeemHistory } from '@/api/portal/redeem'

export default {
  name: 'RedeemCodeModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      codeInput: '',
      submitting: false,
      loadingHistory: false,
      history: [],
      errorMsg: '',
      successMsg: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.codeInput = ''
        this.errorMsg = ''
        this.successMsg = ''
        this.loadHistory()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    loadHistory() {
      this.loadingHistory = true
      getRedeemHistory()
        .then(res => {
          this.history = res.data || []
        })
        .catch(() => {
          this.history = []
        })
        .finally(() => {
          this.loadingHistory = false
        })
    },
    handleSubmit() {
      const raw = (this.codeInput || '').trim()
      if (!raw) {
        this.errorMsg = '请输入兑换码'
        return
      }
      this.errorMsg = ''
      this.successMsg = ''
      this.submitting = true
      submitRedeemCode(raw)
        .then(res => {
          const data = res.data || {}
          this.successMsg = `兑换成功，到账 ${(data.quotaAmount || 0).toLocaleString()} 点`
          this.codeInput = ''
          this.loadHistory()
          this.$emit('success', data)
        })
        .catch(err => {
          this.errorMsg = (err && err.msg) || (err && err.message) || '兑换失败'
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.modal-panel {
  position: relative;
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  overflow: auto;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: var(--text-secondary);
}

.modal-header-bg {
  height: 72px;
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  border-radius: 20px 20px 0 0;
}

.modal-title-row {
  margin-top: -40px;
  padding: 0 28px 8px;
  position: relative;
  z-index: 1;
}

.modal-title-row h2 {
  margin: 0;
  font-size: 22px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.subtitle {
  margin: 8px 0 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
}

.modal-body {
  padding: 20px 28px 28px;
}

.input-row {
  display: flex;
  gap: 10px;
}

.code-input {
  flex: 1;
  height: 44px;
  padding: 0 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  letter-spacing: 0.05em;
}

.submit-btn {
  flex-shrink: 0;
  height: 44px;
  padding: 0 20px;
  border-radius: 10px;
  background: var(--primary);
  color: #fff;
  font-weight: 600;
}

.submit-btn:disabled {
  opacity: 0.6;
}

.error-msg {
  margin: 10px 0 0;
  color: #dc2626;
  font-size: 13px;
}

.success-msg {
  margin: 10px 0 0;
  color: #059669;
  font-size: 13px;
}

.history-block {
  margin-top: 24px;
}

.history-block h3 {
  margin: 0 0 12px;
  font-size: 16px;
}

.history-empty {
  color: var(--text-muted);
  font-size: 13px;
  padding: 16px 0;
  text-align: center;
}

.history-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #eef0f4;
  border-radius: 12px;
}

.history-list li {
  padding: 12px 14px;
  border-bottom: 1px solid #f3f4f6;
}

.history-list li:last-child {
  border-bottom: none;
}

.history-main {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.history-points {
  color: #059669;
  font-weight: 600;
}

.history-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 12px;
  color: var(--text-muted);
}
</style>
